import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";


export const useMenuConfig = (type, enabled = true) => {
    return useQuery({
        queryKey: ['menu_config', type],
        queryFn: async () => getData(`/config/menu-${type}`),
        gcTime: 1000 * 60 * 60 * 2,
        enabled: enabled
    })
}